import { ApolloLink } from 'apollo-link'
import { decamelizeKeys } from 'humps'

const decamelizeLink = new ApolloLink((operation, forward) => {
  const { decamelizeVariables } = operation.getContext()

  if (decamelizeVariables == null || decamelizeVariables) {
    operation.variables = decamelizeKeys(operation.variables)
  }

  return forward(operation)
})

export default decamelizeLink



// WEBPACK FOOTER //
// ./src/config/apollo/decamelizeLink.js